module.exports = __webpack_public_path__ + "img/enidef.df2e9121.jpg";